import type { TemplateSection } from 'inspection-types';

import type { SectionId } from '../model/operations';

export type RailEntryViewModel = {
  id: string;
  name: string;
  isHidden: boolean;
  isActive: boolean;
};

export type SectionsRailViewModel = {
  entries: RailEntryViewModel[];
};

export function createSectionsRailViewModel(
  sortedSections: TemplateSection[],
  activeSectionId: SectionId | null
): SectionsRailViewModel {
  return {
    entries: sortedSections.map(section => ({
      id: section.id,
      name: section.name,
      isHidden: Boolean(section.removed),
      isActive: section.id === activeSectionId,
    })),
  };
}
